import React, { useState } from "react";
import { ASSETS } from "@/lib/content";
import { mediaUrl } from "@/lib/api";

const KEY = "adc_age_verified";

export const AgeGate = () => {
  const [verified, setVerified] = useState(() => localStorage.getItem(KEY) === "true");
  const [denied, setDenied] = useState(false);

  if (verified) return null;

  const confirm = () => {
    localStorage.setItem(KEY, "true");
    setVerified(true);
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 backdrop-blur-xl grain px-6"
      data-testid="age-gate"
    >
      <div
        className="relative w-full max-w-lg border border-gold/25 bg-gradient-to-b from-noir-2/90 to-black/90 px-8 py-14 sm:px-14 text-center"
        style={{ boxShadow: "0 0 80px rgba(212,175,55,0.08)" }}
      >
        <div className="flex justify-center mb-8">
          <img
            src={mediaUrl(ASSETS.logo)}
            alt="After Dark Chocolates"
            className="w-full max-w-sm object-contain mix-blend-screen"
            data-testid="age-gate-logo"
          />
        </div>
        <h1 className="font-serif text-4xl sm:text-5xl text-cream leading-tight mb-6">
          Are you of legal age?
        </h1>
        <p className="font-body text-sm text-white/60 leading-relaxed mb-9 max-w-sm mx-auto">
          This boutique contains adult novelty confections intended for mature audiences.
          Please confirm you are 18 years or older to step inside.
        </p>

        {denied ? (
          <p className="font-body text-sm text-white/60" data-testid="age-denied">
            You must be 18 or older to enter. Please close this page.
          </p>
        ) : (
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={confirm}
              data-testid="age-confirm-btn"
              className="px-8 py-3 bg-gold text-black font-body uppercase tracking-widest text-xs hover:bg-champagne transition-colors duration-300"
            >
              I am 18 or older — Enter
            </button>
            <button
              onClick={() => setDenied(true)}
              data-testid="age-deny-btn"
              className="px-8 py-3 border border-white/20 text-white/70 font-body uppercase tracking-widest text-xs hover:border-gold/50 hover:text-cream transition-colors duration-300"
            >
              I am under 18
            </button>
          </div>
        )}
        <p className="mt-10 font-body text-[10px] tracking-widest uppercase text-white/30">
          Proudly inclusive · All adult lovers welcome
        </p>
      </div>
    </div>
  );
};

export default AgeGate;
